import React from 'react';
import ServicePage from '../components/services/ServicePage';
import pvcBanners from '../data/services/pvc-banners';

const PvcBanners: React.FC = () => <ServicePage data={pvcBanners} />;

export default PvcBanners;
